module.exports = __webpack_public_path__ + "static/media/fedex.1892d0a2.svg";